export const FETCH_SUBSCRIPTIONS_REQUEST = 'FETCH_SUBSCRIPTIONS_REQUEST';
export const FETCH_SUBSCRIPTIONS_SUCCESS = 'FETCH_SUBSCRIPTIONS_SUCCESS';
export const FETCH_SUBSCRIPTIONS_FAILURE = 'FETCH_SUBSCRIPTIONS_FAILURE';
export const FETCH_UNSUBSCRIPTIONS_REQUEST = 'FETCH_UNSUBSCRIPTIONS_REQUEST';
export const FETCH_UNSUBSCRIPTIONS_SUCCESS = 'FETCH_UNSUBSCRIPTIONS_SUCCESS';
export const FETCH_UNSUBSCRIPTIONS_FAILURE = 'FETCH_UNSUBSCRIPTIONS_FAILURE';
export const FETCH_SUBSCRIBE_REQUEST = 'FETCH_SUBSCRIBE_REQUEST';
export const FETCH_SUBSCRIBE_SUCCESS = 'FETCH_SUBSCRIBE_SUCCESS';
export const FETCH_SUBSCRIBE_FAILURE = 'FETCH_SUBSCRIBE_FAILURE';
